import { Injectable } from '@angular/core';
import {ViewModelType} from "../../models/type/view-model-type.enum";
import {TableOperationExecution} from "./table-operation-execution";
import {TableOperationModel} from "../../models/table-operation/table-operation-model";
import {ContentModel} from "../../models/content/content-model";
import {RequestService} from "../request/request.service";

@Injectable({
  providedIn: 'root'
})
export class TableOperationExecutionService {

  constructor(private requestService: RequestService) { }

  processCondition(tableName: string, operation: TableOperationModel, contentModel: ContentModel, options: any, record: any, formType: ViewModelType): boolean {
    const execution = new TableOperationExecution(tableName, operation, contentModel, options, formType, this.requestService);
    return execution.processCondition(record);
  }

  execute(tableName: string, operation: TableOperationModel, contentModel/*or field?*/: ContentModel, options: any, record/* or data?*/: any, formType: ViewModelType): any {
    const execution = new TableOperationExecution(tableName, operation, contentModel, options, formType, this.requestService);
    return execution.execute(record);
  }

  executeMultiple(tableName: string, operation: TableOperationModel, contentModel/*or field?*/: ContentModel, options: any, records/* or data?*/: any, formType: ViewModelType): any {
    const execution = new TableOperationExecution(tableName, operation, contentModel, options, formType, this.requestService);
    return execution.executeMultiple(records);
  }
}
